import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useCookies, withCookies } from "react-cookie";

import "./owner.styles.scss";

import {
  Container,
  Row,
  Col,
  Modal,
  Spinner,
  Image,
  Form,
} from "react-bootstrap";
import Footer from "../../components/Footer/footer.component";
import Header from "../../components/Header/header.component";
import Button from "../../components/Button/button.component";
import TextInput from "../../components/TextInput/text-input.component";

import {
  addTeacher,
  getTeacher,
  setStatusDefault,
} from "../../redux/owner/owner.action";
import { toast } from "react-toastify";

const AddTeacher = ({ nextStep, setSelectedStep }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { addTeacherStatus, isLoadingTeacher, teacher } = useSelector(
    (state) => state.owner
  );
  const [cookies] = useCookies(["user"]);

  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [sendEmail, setSendEmail] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    let params = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone_number: phoneNumber,
      send_welcome_email: sendEmail ? 1 : 0,
    };
    dispatch(addTeacher(params, cookies.user?.token, cookies.user?.studio_id));
  };

  useEffect(() => {
    if (addTeacherStatus === "success") {
      nextStep();
      dispatch(setStatusDefault());
    }
  }, [addTeacherStatus]);

  useEffect(() => {
    dispatch(getTeacher(cookies.user?.token, cookies.user?.studio_id, 1));
  }, []);

  return (
    <Col>
      <div
        className="custom-card align-items-center mx-auto"
        style={{
          paddingLeft: 100,
          paddingRight: 100,
          paddingTop: 20,
          paddingBottom: 50,
          maxWidth: "32rem",
        }}
      >
        <span className="textTitle">Add Teacher</span>
        <Form onSubmit={handleSubmit} style={{ width: "100%" }}>
          <Form.Group style={{ marginBottom: 10 }}>
            <TextInput
              required
              label="First Name"
              placeholder="John"
              onChange={(event) => {
                setFirstName(event.target.value);
              }}
            />
          </Form.Group>
          <Form.Group style={{ marginBottom: 10 }}>
            <TextInput
              label="Last Name"
              placeholder="Chena"
              onChange={(event) => {
                setLastName(event.target.value);
              }}
            />
          </Form.Group>
          <Form.Group style={{ marginBottom: 10 }}>
            <TextInput
              required
              label="Email Address"
              placeholder="John@gmail.com"
              onChange={(event) => {
                setEmail(event.target.value);
              }}
            />
          </Form.Group>
          <Form.Group style={{ marginBottom: 10 }}>
            <TextInput
              type="number"
              label="Phone Number"
              placeholder="087878****"
              value={phoneNumber}
              onChange={(event) => {
                setPhoneNumber(event.target.value);
              }}
            />
          </Form.Group>
          <Form.Group>
            <Form.Check
              id="sent"
              type="checkbox"
              label="Send welcome email"
              style={{ fontFamily: "Roboto", fontSize: 14, color: "#000" }}
              onChange={(event) => {
                setSendEmail(event.target.checked);
              }}
            />
          </Form.Group>
          <Row style={{ marginTop: 20 }}>
            <>
              <Col>
                <Button
                  buttonType="button"
                  isLoading={isLoadingTeacher}
                  type="secondary"
                  title="Skip for now"
                  onClick={() => {
                    if (teacher?.data.length === 0) {
                      setSelectedStep(4);
                    } else {
                      nextStep();
                    }
                  }}
                />
              </Col>
              <Col>
                <Button
                  buttonType="submit"
                  isLoading={isLoadingTeacher}
                  type="primary"
                  title="CONTINUE"
                />
              </Col>
            </>
          </Row>
        </Form>
      </div>
    </Col>
  );
};

export default AddTeacher;
